import { render, staticRenderFns } from "./SalesTeamCard.vue?vue&type=template&id=33bb3bf2&scoped=true&"
import script from "./SalesTeamCard.vue?vue&type=script&lang=js&"
export * from "./SalesTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./SalesTeamCard.vue?vue&type=style&index=0&id=33bb3bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb3bf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
